export default [
  {
    name: "Hugo Theorell, HS ",
    id: "443b701c-0d58-48bc-9cb6-9ac6044513da",
  },
  {
    name: "Granitsalen, CA",
    id: "aab7c369-e0b4-4f46-a195-688c95d9da5d",
  },
  {
    name: "Antracit, ALC",
    id: "d09eb425-1b85-40fa-88c6-e91bde4642c8",
  },
  {
    name: "Dolomit, IKT",
    id: "0c153552-a46e-4180-b83c-57aecc7fae3e",
  },
  {
    name: "Flinta",
    id: "7a6685f3-9589-424c-bd2d-c714379c2ce8",
  },
  {
    name: "Skiffer",
    id: "f2cb2b8b-aa96-4d65-942e-b591b038785c",
  },
  {
    name: "Gnejs",
    id: "22e6da92-4480-48ac-955b-d871099cef41",
  },
  {
    name: "Glimmer",
    id: "b9c290a7-eeca-49e9-acb8-feef808c730a",
  },
  {
    name: "Marmor",
    id: "4fc6d69d-2c40-4426-ac5c-2a98ceb49e5c",
  },
]; /* .map(({ name, id }) => ({
  name,
  id,
  locationId: locations.campusUS.house448.id
})) */
